import React, { useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useUserPreferences } from '../../contexts/UserPreferencesContext';
import { useTheme } from '../../lib/theme';
import { useAmbientBackground } from '../../hooks/useAmbientBackground';
import { useNightModeStyles } from '../../hooks/useNightModeStyles';
import { useOrbPosition } from '../../hooks/useOrbPosition';
import { toast } from "sonner";
import OnboardingStep1 from './OnboardingStep1';
import OnboardingStep2 from './OnboardingStep2';
import OnboardingStep3 from './OnboardingStep3';
import '../../styles/hourly-gradients.css';
import '../../styles/atmospheric-noise.css';
const OnboardingFlow = ({
  onComplete
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [userData, setUserData] = useState({
    name: '',
    location: '',
    coordinates: null,
    temperatureBias: null,
    isNewcomer: null,
    arrivalMonth: ''
  });
  const {
    completeOnboarding
  } = useUserPreferences();
  const {
    theme,
    toggleTheme
  } = useTheme();
  const {
    gradientClass
  } = useAmbientBackground();
  const {
    getNightModeClass
  } = useNightModeStyles();
  const orbPosition = useOrbPosition();
  const handleNext = () => {
    setCurrentStep(prev => prev + 1);
  };
  const handleBack = () => {
    setCurrentStep(prev => prev - 1);
  };
  const handleComplete = async finalData => {
    console.log('OnboardingFlow handleComplete called with:', finalData);
    try {
      console.log('Calling completeOnboarding...');
      const result = await completeOnboarding(finalData);
      console.log('completeOnboarding result:', result);
      toast.success(`Welcome ${finalData.name}! Your preferences have been saved.`);

      // For authenticated users, navigate to personalized page
      // For guest users, they'll see the ConversationalHome
      if (onComplete) {
        onComplete(finalData);
      }
    } catch (error) {
      console.error('Failed to complete onboarding:', error);
      toast.error('Failed to save preferences. Please try again.');
    }
  };
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <OnboardingStep1 onNext={handleNext} userData={userData} setUserData={setUserData} />;
      case 2:
        return <OnboardingStep2 onNext={handleNext} onBack={handleBack} userData={userData} setUserData={setUserData} />;
      case 3:
        return <OnboardingStep3 onComplete={handleComplete} onBack={handleBack} userData={userData} setUserData={setUserData} />;
      default:
        return null;
    }
  };
  return <div className={`min-h-screen bg-gray-50 dark:bg-gray-900 ${gradientClass} ${getNightModeClass()} flex flex-col items-center justify-center p-4 relative font-inter`}>
      <div className="noise-overlay"></div>
      <div className="orb-effect" style={{
      top: `${orbPosition.top}%`,
      left: `${orbPosition.left}%`
    }}></div>

      {/* Back button and Theme Toggle */}
      {currentStep > 1 && <div className="fixed top-4 left-4 z-50 flex items-center gap-2">
          <button onClick={handleBack} className="flex items-center justify-center w-10 h-10 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-full border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 shadow-lg">
            <ChevronLeft className="h-5 w-5 text-gray-600 dark:text-gray-400" />
          </button>
        </div>}

      {/* Theme Toggle - Top Right */}
      <div className="fixed top-4 right-4 z-50">
        <button onClick={toggleTheme} className="flex items-center justify-center w-10 h-10 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-full border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 shadow-lg">
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>
      </div>

      {/* Progress indicator */}
      <div className="w-full max-w-md mb-8">
        <div className="flex justify-center space-x-2 mb-4">
          {[1, 2, 3].map(step => <div key={step} className={`w-3 h-3 rounded-full transition-all duration-300 ${step <= currentStep ? 'bg-blue-500 dark:bg-blue-400' : 'bg-gray-300 dark:bg-gray-600'}`} />)}
        </div>
        <p className="text-center text-body-sm text-muted-foreground">
          Step {currentStep} of 3
        </p>
      </div>

      {/* Main content */}
      <div className="w-full max-w-md">
        {renderStep()}
      </div>

      {/* Branding footer */}
      <div className="mt-8 text-center">
        <p className="text-caption text-muted-foreground">personalized clothing recommendations</p>
      </div>
    </div>;
};
export default OnboardingFlow;